export interface OnlyPlayedDraftState {
  draft: boolean;
  applied: boolean;
}

export function createOnlyPlayedDraft(applied = false): OnlyPlayedDraftState {
  return {
    draft: !!applied,
    applied: !!applied,
  };
}

export function toggleOnlyPlayedDraft(state: OnlyPlayedDraftState): OnlyPlayedDraftState {
  return {
    ...state,
    draft: !state.draft,
  };
}

export function applyOnlyPlayedDraft(state: OnlyPlayedDraftState): OnlyPlayedDraftState {
  return {
    draft: state.draft,
    applied: state.draft,
  };
}

export function resetOnlyPlayedDraft(): OnlyPlayedDraftState {
  return createOnlyPlayedDraft(false);
}

export function syncOnlyPlayedDraftFromInput(applied: boolean): OnlyPlayedDraftState {
  return createOnlyPlayedDraft(applied);
}
